module.exports = __webpack_public_path__ + "static/media/gallery02.303798e7.jpg";